var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StyledLangSelect',[_c('a',{staticClass:"current-locale-link selected",attrs:{"id":"current-locale-link","href":"#"}},[_vm._v(_vm._s(_vm.selected))]),_c('ul',_vm._l((_vm.langs),function(lang,key){return _c('li',{key:key},[_c('a',{on:{"click":function($event){return _vm.changeLanguage(key)}}},[_vm._v(_vm._s(lang))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }